import { createSelector, createSlice } from '@reduxjs/toolkit';
import qs from 'qs';
import * as R from 'ramda';
import http from 'utils/http';
import { generateSearchParams } from 'utils/helpers/fetch';

const initialState = {
  error: '',
  pending: false,
  productsList: [],
};

const reducers = {
  fetchProductsError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  fetchProductsPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  fetchProductsSuccess(state, { payload }) {
    return R.assoc('productsList', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'products',
  reducers,
});

const { fetchProductsPending, fetchProductsSuccess, fetchProductsError } = actions;

// Selectors
const productListSelector = state => state.pto.products.productsList;
export const getProductOptions = createSelector(productListSelector, products =>
  products.map(({ productId, productName }) => ({
    label: `${productName}`,
    value: `${productId}`,
  }))
);

// Actions
let fetchController;
export function fetchProducts() {
  return (dispatch, getState) => {
    const { currentAffiliate } = getState().pto.searchPtos;
    const formattedAffiliate = currentAffiliate
      ? {
          affiliate: {
            companyCustomerIdName: currentAffiliate.customerIdName,
            dataCompanyId: currentAffiliate.dataCompanyId,
          },
        }
      : null;
    const paramString = qs.stringify(
      generateSearchParams(getState().pto.searchPtoFilters, formattedAffiliate),
      { allowDots: true, encode: false }
    );
    dispatch(fetchProductsPending(true));
    if (fetchController) fetchController.abort();
    fetchController = new AbortController();
    const { signal } = fetchController;
    http
      .get(`/product-transfer-orders/get-unique-products-list?${paramString}`, { signal })
      .then(res => {
        dispatch(fetchProductsError(''));
        dispatch(fetchProductsSuccess(res.data));
        dispatch(fetchProductsPending(false));
      });
  };
}

export default reducer;
